import { render, staticRenderFns } from "./LogoAutoteile24SmallSvg.vue?vue&type=template&id=5c828405"
import script from "./LogoAutoteile24SmallSvg.vue?vue&type=script&lang=js"
export * from "./LogoAutoteile24SmallSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports